<template>
  <v-btn-toggle
    v-model="internalActiveIndex"
    class="card-score-buttons__btn-group"
    :class="{ 'card-score-buttons__btn-group--closing': closing }"
    rounded="lg"
    density="compact"
    variant="flat"
    color="primary"
    divided
    @animationend="handleAnimationEnd"
  >
    <v-btn
      v-for="(value, vi) in internalValues"
      :key="value"
      data-test="score-btn"
      :disabled="submitting"
      :style="{ width: '34px', height: '34px', minWidth: '34px' }"
      @click.stop="handleScoreClick(value, vi)"
    >
      {{ value }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: "CardScoreButtons",
  props: {
    maxScore: {
      type: Number,
      default: 6
    },
    submitting: {
      type: Boolean,
      default: false
    },
    closing: {
      type: Boolean,
      default: false
    },
    score: {
      type: Number,
      default: null
    }
  },
  emits: ["score", "close-end"],
  data () {
    return {
      localActiveIndex: null
    };
  },
  computed: {
    internalValues () {
      return Array.from({ length: this.maxScore + 1 }, (_, i) => i);
    },
    internalActiveIndex: {
      get () {
        if (this.score != null) {
          return this.internalValues.indexOf(this.score);
        }
        return this.localActiveIndex ?? this.internalValues.length - 1;
      },
      set (val) {
        this.localActiveIndex = val;
      }
    }
  },
  methods: {
    handleScoreClick (value, vi) {
      if (vi === this.internalValues.length - 1) return;
      this.localActiveIndex = vi;
      this.$emit("score", value);
    },
    handleAnimationEnd (event) {
      if (event.animationName === "scoreButtonsFadeOut") {
        this.$emit("close-end");
      }
    }
  }
};
</script>

<style scoped>
.card-score-buttons__btn-group {
  border: 1px solid rgba(var(--v-border-color), 0.3);
  animation: scoreButtonsFadeIn .3s ease-in-out;
}
.card-score-buttons__btn-group--closing {
  animation: scoreButtonsFadeOut .3s ease-in-out forwards;
}
@keyframes scoreButtonsFadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes scoreButtonsFadeOut {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(4px); }
}
</style>
